/**
 * @generated SignedSource<<0991bed2320c2ccb36d5bf19abaa30b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorSeoAuthor$data = {
  readonly bio: string | null;
  readonly entityId: string;
  readonly name: string;
  readonly " $fragmentType": "authorSeoAuthor";
};
export type authorSeoAuthor$key = {
  readonly " $data"?: authorSeoAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorSeoAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorSeoAuthor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "8d9a5dfdd53105b25f3a911005afcf48";

export default node;
